function vdpConsumerReviewSectionService ($http, $q) {
    let tagCache = {};

    function getReviewsByTag(mmyStepId, tagValue, reviewApiHost, apikey) {
        let deferred = $q.defer();
        if (tagCache[tagValue]) {
            deferred.resolve(tagCache[tagValue]);
        } else {
            let params = {
                perPage: 3,
                incTotalsData: false,
                incReviewTags: false,
                apikey: apikey
            };
            if (tagValue != "all") {
                params.tagCode = tagValue;
            } else {
                params.orderBy = 'submittedDate',
                params.sortDir = 'DESC';
            }

            $http.get(reviewApiHost + '/consumerVehicleReviewRetrievalService/1.0/rest/' + mmyStepId + '/reviewData', {params})
                .then((response) => {
                    if (response.status == 200) {
                        tagCache[tagValue] = response.data.reviews;
                        deferred.resolve(response.data.reviews);
                    } else {
                        deferred.reject(response);
                    }
            }).catch((err) => {
                deferred.reject(err);
            });
        }
        return deferred.promise;
    }

    return {
        getReviewsByTag
    };
}

vdpConsumerReviewSectionService.$inject = [
    '$http',
    '$q'
];

export default vdpConsumerReviewSectionService;